export default __webpack_public_path__ + "static/media/tv-svgrepo-com.1b0d1ee5.svg";